import React from "react";
import { useAuth } from "../hooks/useAuth";
import { useNetworkStatus } from "../hooks/useNetworkStatus";
import { useSyncStatus } from "../hooks/useSyncStatus";

const SyncStatusIndicator: React.FC = () => {
  const { user } = useAuth();
  const { isSyncing, pending, failed } = useSyncStatus(user);
  const isOnline = useNetworkStatus();

  if (pending === 0 && failed === 0 && !isSyncing) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 pointer-events-none">
      <div className="max-w-md mx-auto p-2">
        <div
          className={`alert shadow-lg pointer-events-auto flex justify-between items-center py-2 px-4 ${
            failed > 0
              ? "alert-error"
              : isSyncing
                ? "alert-info"
                : "alert-warning"
          }`}
        >
          <div className="flex items-center gap-3">
            {isSyncing ? (
              <span className="loading loading-spinner loading-sm"></span>
            ) : failed > 0 ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current shrink-0 h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current shrink-0 h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            )}

            <div className="text-xs font-medium">
              {failed > 0 ? (
                <span>
                  {failed} échec(s) d'envoi
                  {isSyncing && " — nouvelle tentative..."}
                </span>
              ) : isSyncing ? (
                <span>Synchronisation en cours... ({pending} restantes)</span>
              ) : (
                <span>
                  {pending} photo(s) en attente {!isOnline && "(Hors-ligne)"}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SyncStatusIndicator;
